module.exports = __webpack_public_path__ + "static/media/info-primary.c01c8ed0.svg";